import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PainPoints() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const painPoints = ['Cada mañana necesitas 20 o 30 minutos para que tu cuerpo "arranque". Rigidez en manos, rodillas o espalda que no existía hace diez años.', 'Tu energía desaparece a las 3 de la tarde como si alguien apagara un interruptor — aunque hayas dormido tus horas completas.', 'Tu digestión es un misterio sin resolver. La hinchazón después de comer, el reflujo que aparece sin aviso, el malestar que ya normalizaste sin darte cuenta.', 'Llevas meses — o años — gastando dinero en suplementos que no cambian absolutamente nada. La cúrcuma, el colágeno, el jengibre en cápsula. Todos prometían. Ninguno cumplió.', 'Las noches son una batalla silenciosa. Te despiertas a las 3 de la madrugada con la mente encendida. El sueño profundo y reparador parece cosa del pasado.', 'Cada consulta médica termina igual: una receta nueva que genera un efecto secundario que requiere otra receta. El ciclo nunca termina.'];
  return <section ref={ref} className="py-12 md:py-20 px-4 bg-white" data-id="element-182">
      <div className="max-w-4xl mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-184">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl text-warm-brown mb-6 md:mb-8 text-center px-2" data-id="element-185">
            Antes de seguir — dime si esto te resulta familiar:
          </h2>

          <div className="space-y-4 md:space-y-6" data-id="element-186">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-3 md:gap-4 items-start bg-cream p-4 md:p-6 rounded-lg border-l-4 border-sage" data-id="element-187">
                <span className="text-sage text-xl md:text-2xl font-bold flex-shrink-0" aria-hidden="true" data-id="element-188">
                  ✦
                </span>
                <p className="text-gray-700 text-base md:text-lg" data-id="element-189">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="mt-8 md:mt-12 text-center px-2" data-id="element-190">
            <p className="text-lg md:text-xl text-gray-700 mb-3 md:mb-4" data-id="element-191">
              Si reconociste aunque sea tres de estos puntos — no estás
              envejeciendo mal.
            </p>
            <p className="text-xl md:text-2xl font-bold text-terracotta" data-id="element-192">
              Estás usando las herramientas equivocadas.
            </p>
            <p className="text-lg md:text-xl text-gray-700 mt-3 md:mt-4" data-id="element-193">
              Y la buena noticia es que eso tiene solución.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}